import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2508568e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"padding-left":"3vw","padding-right":"3vw","padding-top":"2vw"} }
const _hoisted_2 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_3 = {
  key: 0,
  class: "app__page__title__container"
}
const _hoisted_4 = {
  class: "app__page__title",
  style: {"white-space":"nowrap"}
}
const _hoisted_5 = { style: {"display":"flex","flex-direction":"row","gap":"10px"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Sterge filtre! ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { style: {"display":"flex","align-items":"start","flex-direction":"row"} }
const _hoisted_9 = {
  key: 3,
  style: {"display":"flex","flex-direction":"row","width":"20rem","overflow-x":"auto","padding-left":"0rem"}
}
const _hoisted_10 = { style: {"text-align":"center","display":"flex","flex-direction":"row","align-items":"center","justify-content":"center"} }
const _hoisted_11 = {
  key: 2,
  class: "app__back__bar--title",
  style: {"position":"absolute","left":"50%","margin-left":"-100px"}
}
const _hoisted_12 = {
  key: 3,
  class: "app__back__bar--title",
  style: {"position":"absolute","left":"calc(50% - 120px)","top":"10px"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_uploader = _resolveComponent("q-uploader")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_vue_pdf_embed = _resolveComponent("vue-pdf-embed")!
  const _directive_close_popup = _resolveDirective("close-popup")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$q.platform.is.desktop)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _createVNode(_component_q_icon, {
                name: "meeting_room",
                style: {"font-size":"2rem","top":"-3px"},
                color: "#273233"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t('message.back_office')), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_q_btn, {
        icon: "restart_alt",
        flat: "",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refreshFilters()))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tooltip, {
            anchor: "top middle",
            self: "bottom middle",
            offset: [10, 10],
            "transition-show": "scale",
            "transition-hide": "scale"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_q_input, {
        outlined: "",
        dense: "",
        modelValue: _ctx.searchInput,
        "onUpdate:modelValue": [
          _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchInput) = $event)),
          _cache[2] || (_cache[2] = ($event: any) => (_ctx.resetPaginationAndFetch()))
        ],
        label: _ctx.$t('message.request_id'),
        style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);')
      }, null, 8, ["modelValue", "label", "style"]),
      (_ctx.user.tip == '1' || _ctx.user.tip == '3')
        ? (_openBlock(), _createBlock(_component_q_input, {
            key: 0,
            outlined: "",
            dense: "",
            modelValue: _ctx.searchCompany,
            "onUpdate:modelValue": [
              _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchCompany) = $event)),
              _cache[4] || (_cache[4] = ($event: any) => (_ctx.resetPaginationAndFetch()))
            ],
            label: _ctx.$t('message.name2'),
            style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);')
          }, null, 8, ["modelValue", "label", "style"]))
        : _createCommentVNode("", true),
      (_ctx.user.tip == '1' || _ctx.user.tip == '3')
        ? (_openBlock(), _createBlock(_component_q_input, {
            key: 1,
            outlined: "",
            dense: "",
            modelValue: _ctx.searchAgent,
            "onUpdate:modelValue": [
              _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchAgent) = $event)),
              _cache[6] || (_cache[6] = ($event: any) => (_ctx.resetPaginationAndFetch()))
            ],
            label: _ctx.$t('message.agent2'),
            style: _normalizeStyle(_ctx.$q.platform.is.mobile ? 'width: 100%;' : 'width:clamp(200px, 40vw, 400px);')
          }, null, 8, ["modelValue", "label", "style"]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_7,
    _createVNode(_component_q_table, {
      grid: _ctx.$q.platform.is.mobile,
      class: "my-sticky-header-table",
      title: "",
      "rows-per-page-options": [10, 25, 50],
      pagination: _ctx.pagination,
      "onUpdate:pagination": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.pagination) = $event)),
      rows: _ctx.offersHeaders,
      columns: _ctx.columns,
      "visible-columns": _ctx.visibleColumns,
      "row-key": "name",
      flat: "",
      bordered: "",
      "no-data-label": _ctx.$t('message.no_data'),
      onRequest: _ctx.onRequest
    }, {
      body: _withCtx((props) => [
        _createVNode(_component_q_tr, { props: props }, {
          default: _withCtx(() => [
            _createVNode(_component_q_td, {
              key: "id_offer",
              props: props,
              style: {"cursor":"pointer","color":"blue"},
              onClick: ($event: any) => (_ctx.onOpenCerere(props.row.id_offer, props.row.track_creation_date))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.row.id_offer), 1)
              ]),
              _: 2
            }, 1032, ["props", "onClick"]),
            _createVNode(_component_q_td, {
              key: "track_creation_date",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.row.track_creation_date), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "nr_articole",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.row.nr_articole), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "track_user_id",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.row.track_user_id), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "cif",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.row.cif), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "denumire",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.row.denumire), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "agent",
              props: props
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(props.row.agent), 1)
              ]),
              _: 2
            }, 1032, ["props"]),
            _createVNode(_component_q_td, {
              key: "status",
              props: props,
              style: _normalizeStyle('font-weight: bold;color: ' + _ctx.statusColor(props.row.status))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.statusHumanReadable(props.row.status)), 1)
              ]),
              _: 2
            }, 1032, ["props", "style"]),
            _createVNode(_component_q_td, {
              key: "upload",
              props: props
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  ((_ctx.user.tip == '1' || _ctx.user.tip == '2'))
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 0,
                        disable: !(props.row.status == 'p' || props.row.status == 'o' || props.row.status == 'm'),
                        flat: "",
                        dense: "",
                        color: "#273233",
                        style: {"min-width":"4rem"},
                        onClick: ($event: any) => (_ctx.showUploadForCerere(props.row.id_offer, props.row.reoffers_count))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            name: "upload",
                            color: "#273233"
                          }),
                          _createVNode(_component_q_tooltip, {
                            anchor: "top middle",
                            self: "bottom middle",
                            offset: [10, 10],
                            "transition-show": "scale",
                            "transition-hide": "scale"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('message.upload_offer')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["disable", "onClick"]))
                    : _createCommentVNode("", true),
                  ((_ctx.user.tip == '1' || _ctx.user.tip == '2'))
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 1,
                        disable: (props.row.status == 'c' || props.row.status == 'p'),
                        flat: "",
                        dense: "",
                        color: "#273233",
                        style: {"max-width":"4rem"},
                        loading: _ctx.resendEmail,
                        onClick: ($event: any) => (_ctx.resendEmailOffer(props.row.id_offer))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            name: "email",
                            color: "#273233"
                          }),
                          _createVNode(_component_q_tooltip, {
                            anchor: "top middle",
                            self: "bottom middle",
                            offset: [10, 10],
                            "transition-show": "scale",
                            "transition-hide": "scale"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('message.resend_email_offer')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["disable", "loading", "onClick"]))
                    : _createCommentVNode("", true),
                  (props.row.status!='p')
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 2,
                        flat: "",
                        color: "#273233",
                        style: {"min-width":"4rem"},
                        onClick: ($event: any) => (_ctx.generareOferta(props.row.id_offer, 0)),
                        disable: !(props.row.status == 'k' || props.row.status == 'o' || props.row.status == 'm')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_icon, {
                            name: "picture_as_pdf",
                            color: "#273233"
                          }),
                          _createVNode(_component_q_tooltip, {
                            anchor: "top middle",
                            self: "bottom middle",
                            offset: [10, 10],
                            "transition-show": "scale",
                            "transition-hide": "scale"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('message.open_offer')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onClick", "disable"]))
                    : _createCommentVNode("", true),
                  (props.row.reoffers_count > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.row.reoffers_count-1, (index) => {
                          return (_openBlock(), _createBlock(_component_q_btn, {
                            key: index,
                            onClick: ($event: any) => (_ctx.generareOferta(props.row.id_offer, index)),
                            flat: "",
                            style: {"min-width":"4rem","display":"flex","align-items":"center","justify-content":"center"},
                            disable: !(props.row.status == 'k' || props.row.status == 'o' || props.row.status == 'm')
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("label", null, _toDisplayString(index) + "  ", 1),
                                _createVNode(_component_q_icon, {
                                  name: "picture_as_pdf",
                                  color: "#273233"
                                }),
                                _createVNode(_component_q_tooltip, {
                                  anchor: "top middle",
                                  self: "bottom middle",
                                  offset: [10, 10],
                                  "transition-show": "scale",
                                  "transition-hide": "scale"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('message.open_offer')), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 2
                          }, 1032, ["onClick", "disable"]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 2
            }, 1032, ["props"])
          ]),
          _: 2
        }, 1032, ["props"])
      ]),
      item: _withCtx((props) => [
        _createVNode(_component_q_card, { class: "my_card_3" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_list, { dense: "" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols.filter(col => { return !col.name.includes('upload')}), (col) => {
                  return (_openBlock(), _createBlock(_component_q_item, {
                    key: col.name
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item_section, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(col.label), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_q_item_section, { side: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_label, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(col.field == 'status' ? _ctx.statusHumanReadable(col.value) : col.value), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 2
            }, 1024),
            _createVNode(_component_q_card_actions, null, {
              default: _withCtx(() => [
                (_ctx.user.tip == '1' || _ctx.user.tip == '2')
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      label: _ctx.$t('message.upload_offer'),
                      style: {"min-width":"4rem"},
                      onClick: ($event: any) => (_ctx.showUploadForCerere(props.row.id_offer, props.row.reoffers_count))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_icon, {
                          name: "upload",
                          color: "#273233"
                        })
                      ]),
                      _: 2
                    }, 1032, ["label", "onClick"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_q_btn, {
                  flat: "",
                  color: "#273233",
                  style: {"min-width":"4rem"},
                  label: _ctx.$t('message.offer_details'),
                  onClick: ($event: any) => (_ctx.generareOferta(props.row.id_offer, props.row.reoffers_count))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "picture_as_pdf",
                      color: "#273233"
                    })
                  ]),
                  _: 2
                }, 1032, ["label", "onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["grid", "pagination", "rows", "columns", "visible-columns", "no-data-label", "onRequest"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.showDialogForUploadPdf,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showDialogForUploadPdf) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_uploader, {
                  url: _ctx.getUrlForUploadProfileImage,
                  label: _ctx.titleUploadCerere,
                  accept: ".pdf, pdf/*",
                  "auto-upload": "",
                  color: "black",
                  capture: "environment",
                  style: {"max-width":"80vw"},
                  onUploaded: _ctx.imgForProfileWasUploaded
                }, null, 8, ["url", "label", "onUploaded"])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, { align: "right" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  label: _ctx.$t('message.drop'),
                  color: "#273233"
                }, null, 8, ["label"]), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.dialogViewOferta,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.dialogViewOferta) = $event)),
      persistent: "",
      maximized: true,
      "transition-show": _ctx.dialogTransitionShow,
      "transition-hide": _ctx.dialogTransitionHide
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "bg-white" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_bar, {
              class: _normalizeClass({ 'bg-blue-grey-11': _ctx.$q.platform.is.desktop , 'bg-white': _ctx.$q.platform.is.mobile })
            }, {
              default: _withCtx(() => [
                (_ctx.$q.platform.is.desktop)
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      dense: "",
                      flat: "",
                      icon: "arrow_back",
                      color: "black",
                      size: "md",
                      onClick: _ctx.closeCurrentView
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, { "content-class": "bg-grey text-white" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('message.close')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.mobile)
                  ? (_openBlock(), _createBlock(_component_q_icon, {
                      key: 1,
                      name: "arrow_back_ios",
                      class: "app__arrow--back",
                      onClick: _ctx.closeCurrentView
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.dynamicComponentTitle) + " " + _toDisplayString(_ctx.selectedOfferSlid) + " / " + _toDisplayString(_ctx.selectedOfferDate), 1))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.mobile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.dynamicComponentTitle) + " " + _toDisplayString(_ctx.selectedOfferSlid) + " / " + _toDisplayString(_ctx.selectedOfferDate), 1))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? (_openBlock(), _createBlock(_component_q_space, {
                      key: 4,
                      dense: ""
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.dynamicComponent), {
                  propOfferId: _ctx.selectedOfferId,
                  closeHandler: _ctx.closeFormViewOferta,
                  fromBackOffice: true
                }, null, 8, ["propOfferId", "closeHandler"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "transition-show", "transition-hide"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.fixed,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.fixed) = $event)),
      "full-width": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "my_card" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center" }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'text-h8' : 'text-h6')
                }, _toDisplayString(_ctx.popupTitle), 3),
                (_ctx.$q.platform.is.desktop)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      "no-caps": "",
                      color: "#273233",
                      onClick: _ctx.downloadPDF,
                      icon: "download",
                      style: {"margin-left":"1rem","cursor":"pointer"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("message.download")), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])), [
                      [_directive_ripple]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.mobile)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 1,
                      "no-caps": "",
                      flat: "",
                      color: "#273233",
                      icon: "download",
                      onClick: _ctx.downloadPDF,
                      style: {"cursor":"pointer"}
                    }, null, 8, ["onClick"])), [
                      [_directive_ripple]
                    ])
                  : _createCommentVNode("", true),
                _createVNode(_component_q_space),
                (_ctx.isLoadingOffer)
                  ? (_openBlock(), _createBlock(_component_q_spinner, {
                      key: 2,
                      color: "black",
                      size: _ctx.$q.platform.is.mobile ? '1.5em' : '3em'
                    }, null, 8, ["size"]))
                  : _createCommentVNode("", true),
                (_ctx.isLoadingOffer)
                  ? (_openBlock(), _createBlock(_component_q_space, { key: 3 }))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 4,
                      icon: "close",
                      flat: "",
                      round: "",
                      dense: ""
                    }, null, 512)), [
                      [_directive_close_popup]
                    ])
                  : _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                      key: 5,
                      icon: "close",
                      flat: "",
                      round: "",
                      dense: "",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.widthPdf=300))
                    }, null, 512)), [
                      [_directive_close_popup]
                    ])
              ]),
              _: 1
            }),
            (_ctx.$q.platform.is.mobile)
              ? (_openBlock(), _createBlock(_component_q_card_section, {
                  key: 0,
                  class: "my_card_2"
                }, {
                  default: _withCtx(() => [
                    (!_ctx.isLoadingOffer)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 0,
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changeWitdhPdf('in'))),
                          icon: "zoom_in",
                          style: {"margin-bottom":"8px"}
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.isLoadingOffer)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 1,
                          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.changeWitdhPdf('out'))),
                          icon: "zoom_out",
                          style: {"margin-left":"10px","margin-bottom":"8px"}
                        }))
                      : _createCommentVNode("", true),
                    _hoisted_13,
                    _createVNode(_component_vue_pdf_embed, {
                      source: _ctx.pdf,
                      width: _ctx.widthPdf
                    }, null, 8, ["source", "width"])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_q_card_section, {
                  key: 1,
                  class: "my_card_2"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_vue_pdf_embed, { source: _ctx.pdf }, null, 8, ["source"])
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}